// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const LinkInstagram: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    color1 = "#fff",
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 18 19" width={width} height={height}>
            <path
                fill="currentColor"
                d="M8.999 5.128a4.607 4.607 0 0 0-4.614 4.615A4.607 4.607 0 0 0 9 14.358a4.607 4.607 0 0 0 4.614-4.615A4.607 4.607 0 0 0 9 5.128m0 7.615c-1.65 0-3-1.345-3-3s1.346-3 3-3 3 1.345 3 3-1.35 3-3 3m5.879-7.804a1.076 1.076 0 1 0-2.153 0 1.076 1.076 0 0 0 2.153 0m3.056 1.093c-.069-1.442-.398-2.72-1.454-3.772C15.428 1.208 14.151.88 12.71.806c-1.486-.084-5.94-.084-7.425 0-1.438.069-2.715.398-3.771 1.45S.133 4.586.06 6.028c-.084 1.486-.084 5.94 0 7.426.069 1.442.398 2.72 1.454 3.772s2.329 1.381 3.77 1.454c1.486.084 5.94.084 7.425 0 1.442-.069 2.719-.398 3.771-1.454 1.052-1.053 1.381-2.33 1.454-3.772.084-1.486.084-5.936 0-7.422m-1.92 9.017a3.04 3.04 0 0 1-1.71 1.71c-1.185.47-3.996.362-5.305.362-1.31 0-4.124.105-5.305-.361a3.04 3.04 0 0 1-1.71-1.711c-.47-1.185-.362-3.997-.362-5.306s-.104-4.125.362-5.306a3.04 3.04 0 0 1 1.71-1.71C4.88 2.256 7.69 2.364 9 2.364s4.124-.105 5.305.361c.787.313 1.393.92 1.71 1.711.47 1.185.362 3.997.362 5.306s.108 4.125-.362 5.306"
            />
        </svg>
    );
};

export default React.memo(LinkInstagram);
